import { render, staticRenderFns } from "./PrintInvoice.vue?vue&type=template&id=28ad54de&scoped=true"
import script from "./PrintInvoice.vue?vue&type=script&lang=js"
export * from "./PrintInvoice.vue?vue&type=script&lang=js"
import style0 from "./PrintInvoice.vue?vue&type=style&index=0&id=28ad54de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ad54de",
  null
  
)

export default component.exports